import apiClient from "./apiClient";

export const getMe = async () => {
  const response = await apiClient.get("/api/auth/me");
  return response.data;
};

export const verifyEmailToken = async (token) => {
  const response = await apiClient.get("/api/auth/verify-email", {
    params: { token },
  });
  return response.data;
};

export const resendVerification = async () => {
  const response = await apiClient.post("/api/auth/resend-verification");
  return response.data;
};

export const refreshJwt = async () => {
  const response = await apiClient.post("/api/auth/refresh");
  return response.data;
};

export const login = async (credentials) => {
    try {
        const response = await apiClient.post('/api/auth/login', credentials);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const signup = async (userData) => {
    try {
        const response = await apiClient.post('/api/auth/signup', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const requestPasswordReset = async ({ email }) => {
  const response = await apiClient.post("/api/auth/forgot-password", { email });
  return response.data;
};

export const resetPassword = async ({ token, password }) => {
  const response = await apiClient.post("/api/auth/reset-password", {
    token,
    password,
  });
  return response.data;
};